import {FuseNavigation} from '@fuse/types';

export const adminFeature: FuseNavigation[] = [
    {
        id: 'features',
        title: 'Features',
        type: 'group',
        children: [
            {
                id: 'driver-app-access',
                title: 'Driver App Access',
                type: 'item',
                children: []
            },
            {
                // Coarse picker-app entry permission. The nested section toggles
                // are disabled unless this is enabled. Defaults OFF (see role.service addVisibility).
                id: 'picker-app-access',
                title: 'Picker App Access',
                type: 'group',
                children: [
                    {
                        id: 'picker-pick-access',
                        title: 'Pick',
                        type: 'item',
                        children: []
                    },
                    {
                        id: 'picker-group-pick-access',
                        title: 'Group Pick',
                        type: 'item',
                        children: []
                    },
                    {
                        id: 'picker-load-orders-access',
                        title: 'Load Orders',
                        type: 'item',
                        children: []
                    },
                    {
                        id: 'picker-receive-inventory-access',
                        title: 'Receive / Adjust Inventory',
                        type: 'item',
                        children: []
                    },
                    {
                        id: 'picker-purchase-orders-access',
                        title: 'Purchase Orders',
                        type: 'item',
                        children: []
                    },
                    {
                        id: 'picker-warehouse-transfers-access',
                        title: 'Warehouse Transfers',
                        type: 'item',
                        children: []
                    },
                    {
                        id: 'picker-stock-take-access',
                        title: 'Stock Take',
                        type: 'item',
                        children: []
                    }
                ]
            },
            {
                id: 'pos-app-access',
                title: 'POS App Access',
                type: 'item',
                children: []
            },
            {
                id: 'client-portal-access',
                title: 'Client Portal Access',
                type: 'item',
                children: []
            },
            {
                id: 'ai-feature',
                title: 'Get AI Feature',
                type: 'item',
                children: []
            }
        ]
    }
];
